import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const pdiCmsService = (api) => {

    const getPdiData = () => {
        return api.get("/api/v1/bff-schema/page/page-template/pre-delivery-inspection");
    };

    const getPdiFaqData = () => {
        return api.get("/api/v1/bff-schema/page/page-template/pdiFaq");
    };

    return {
        getPdiData,
        getPdiFaqData
    };
};

export const PdiCmsService = pdiCmsService(middlewareConfig(MIDDLEWARE_ENUMS.PDI_CMS_SERVICE));
